var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:{ open: _vm.isOpen }},[_vm._t("trigger",null,null,{ isOpen: _vm.isOpen, toggle: _vm.toggle }),_vm._v(" "),_vm._t("collapsible",null,null,{ isOpen: _vm.isOpen, toggle: _vm.toggle, close: _vm.close })],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2ae8806","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/Collapsible.vue
// module id = TIO7
// module chunks = 1